export default {
  edit: '修改',
  editTitle: '修改机器狗信息',
  cancel: '取消',
  confirm: '确认',
  fieldSn: '设备SN',
  fieldAlias: '别名',
  fieldNameEn: '英文别名',
  fieldDeviceType: '设备类型',
  fieldLongitude: '经度',
  fieldLatitude: '纬度',
  placeholderSn: '请输入设备SN',
  placeholderAlias: '请输入别名',
  placeholderNameEn: '请输入英文别名',
  placeholderDeviceType: '请输入设备类型',
  placeholderLongitude: '请输入经度（可选）',
  placeholderLatitude: '请输入纬度（可选）',
  ruleSn: '请输入设备SN',
  ruleAlias: '请输入别名',
  ruleNameEn: '请输入英文别名',
  ruleDeviceType: '请输入设备类型',
  successUpdate: '修改成功',
  failUpdate: '修改失败',
}
